export default () => ({
    marginTop: '1rem',
    '& .ant-spin': {
        display: 'block',
        margin: 'auto',
    },
});
